/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import { useIntl } from 'react-intl'
import {
  TYPE_APARTMENT,
  TYPE_COMMERCIAL_PREMISE,
  TYPE_HOUSE,
  TYPE_TERRAIN
} from '../../enums/EstateTypeCodes.mjs'
import FormField from '../../../../client/js/components/form/fields/FormField'
import { Select, SelectProps } from '@mantine/core'

export type EstateTypeFieldProps = Omit<SelectProps, 'data'>

function EstateTypeField (props: EstateTypeFieldProps) {
  const { name = 'type', ...others } = props
  const intl = useIntl()
  return (
    <FormField
      allowDeselect={false}
      name={name}
      label={intl.formatMessage({
        id: 'type',
        defaultMessage: 'Type'
      })}
      render={Select}
      data={[
        {
          label: intl.formatMessage({
            id: 'apartment',
            defaultMessage: 'Appartement'
          }),
          value: TYPE_APARTMENT
        },
        {
          label: intl.formatMessage({
            id: 'house',
            defaultMessage: 'Maison'
          }),
          value: TYPE_HOUSE
        },
        {
          label: intl.formatMessage({
            id: 'commercial_premise',
            defaultMessage: 'Local'
          }),
          value: TYPE_COMMERCIAL_PREMISE
        },
        {
          label: intl.formatMessage({
            id: 'terrain',
            defaultMessage: 'Terrain'
          }),
          value: TYPE_TERRAIN
        }
      ]}
      {...others}
    />
  )
}

export default EstateTypeField
